import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, IconButton, Radio } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { palette } from "../../themes/theme";
import { useDispatch, useSelector } from "react-redux";
import {
  updateActiveEnvType,
  updateShadingSettings,
} from "../../redux/slices/mapSlice";
import { showLoader } from "../../redux/slices/loaderSlice";
import {
  environmentalRiskLayer,
  defaultEnvRiskLayerData,
  normalizeEnvLegendValues,
} from "../../utils/helper";
import { updateLegendAsPalette } from "./CrimeRiskReports";
// import { addSelectedLayer, removeSelectedLayer } from "../../redux/slices/mapSlice";

const RadioBox = ({
  label,
  value,
  checked,
  onChange,
  disabled,
  onClickConfiguration,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        background: palette.background.light,
        px: 1,
        opacity: !disabled ? 1 : 0.4,
      }}
    >
      <FormControlLabel
        control={
          <Radio
            checked={checked}
            onClick={onChange}
            value={value}
            name="crime-risk-reports"
            sx={{ color: palette.primary.main }}
          />
        }
        label={label}
      />
      {checked && (
        <IconButton onClick={onClickConfiguration}>
          <SettingsIcon fontSize="medium" color="primary" />
        </IconButton>
      )}
    </Box>
  );
};

const EnvironmentalRiskReports = ({ handleOpenModal }) => {
  const activeEnvType = useSelector((state) => state.map.activeEnvType);
  const shadingSettings = useSelector((state) => state.map.shadingSettings);
  const dispatch = useDispatch();

  const [environmentalRiskLayerState, setEnvironmentalRiskLayerState] =
    useState(environmentalRiskLayer);
  const [selecteEnvType, setSelecteEnvType] = useState(activeEnvType);

  useEffect(() => {
    setEnvironmentalRiskLayerState(environmentalRiskLayer);
  }, []);

  useEffect(() => {
    setSelecteEnvType(activeEnvType);
  }, [activeEnvType]);

  const handleSelectLayerChange = (e) => {
    dispatch(
      showLoader({
        showLoader: true,
        showBackDrop: true,
      })
    );
    if (selecteEnvType !== e.target.value) {
      const colorScheme = updateLegendAsPalette(
        shadingSettings.legendColorSchemeData.length > 0
          ? shadingSettings.legendColorSchemeData
          : defaultEnvRiskLayerData,
        defaultEnvRiskLayerData
      );
      // localStorage.setItem(
      //   "preferedColorPalette",
      //   JSON.stringify({
      //     ...shadingSettings,
      //     defaultKey: null,
      //     legendColorSchemeData: colorScheme
      //   })
      // );
      setSelecteEnvType(e.target.value);
      dispatch(updateActiveEnvType(e.target.value));
      dispatch(
        updateShadingSettings({
          ...shadingSettings,
          legendColorSchemeData: normalizeEnvLegendValues([...colorScheme]),
          defaultKey: null,
          useGradings: false,
        })
      );
    } else {
      dispatch(updateActiveEnvType(null));
      setSelecteEnvType(null);
    }
    setTimeout(() => {
      dispatch(
        showLoader({
          showLoader: false,
          showBackDrop: false,
        })
      );
    }, 2000);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {environmentalRiskLayerState?.length > 0 &&
        environmentalRiskLayerState.map((layer) => (
          <RadioBox
            key={layer.id}
            label={layer.title}
            value={layer.id}
            checked={selecteEnvType === layer.id}
            disabled={layer.disable}
            onChange={handleSelectLayerChange}
            onClickConfiguration={handleOpenModal}
          />
        ))}
    </Box>
  );
};

export default EnvironmentalRiskReports;
